import * as React from 'react';
import classnames from 'classnames';

export interface IModalHeader {
    onClose?: (event) => void;
}

const ModalHeader: React.SFC<any> = (props) => {
    const { children, className, onClose, ...attributes } = props;
    return (
        <div
            className={classnames('modal-header', {
                className
            })}
            {...attributes}
        >
            {children}
            <button
                type="button"
                className="modal-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
            >
                <span aria-hidden="true">
                    <i className="nx nx-close"></i>
                </span>
            </button>
        </div>
    );
};

export default ModalHeader;
